import React from 'react'

const DisplayStars = props => {
    return (
        <div className='w-100 text-center'>
            <div className='d-inline-block' style={{ width: '16px' }}>
                <img key={`$1-${props.nbRatings}`} className={'img-fluid star-1'} src={(props.note > 0.5 && '/images/star-filled-48.png') || (props.note <= 0 && '/images/star-empty-48.png') || '/images/star-half-empty-48.png'} alt='star' />
            </div>
            <div className='d-inline-block' style={{ width: '16px' }}>
                <img key={`$2-${props.nbRatings}`} className={'img-fluid star-2'} src={(props.note > 1.5 && '/images/star-filled-48.png') || (props.note <= 1 && '/images/star-empty-48.png') || '/images/star-half-empty-48.png'} alt='star' />
            </div>
            <div className='d-inline-block' style={{ width: '16px' }}>
                <img key={`$3-${props.nbRatings}`} className={'img-fluid star-3'} src={(props.note > 2.5 && '/images/star-filled-48.png') || (props.note <= 2 && '/images/star-empty-48.png') || '/images/star-half-empty-48.png'} alt='star' />
            </div>
            <div className='d-inline-block' style={{ width: '16px' }}>
                <img key={`$4-${props.nbRatings}`} className={'img-fluid star-4'} src={(props.note > 3.5 && '/images/star-filled-48.png') || (props.note <= 3 && '/images/star-empty-48.png') || '/images/star-half-empty-48.png'} alt='star' />
            </div>
            <div className='d-inline-block' style={{ width: '16px' }}>
                <img key={`$5-${props.nbRatings}`} className={'img-fluid star-5'} src={(props.note > 4.5 && '/images/star-filled-48.png') || (props.note <= 4 && '/images/star-empty-48.png') || '/images/star-half-empty-48.png'} alt='star' />
            </div>
        </div>
    )
}

export default DisplayStars
